import React from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';
import { useTheme } from "@mui/material/styles";
const PageLoader = () => {
const theme = useTheme();
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.8)', 
        backdropFilter: 'blur(8px)', 
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center', 
        zIndex: 1300, 
      }}
    >
      <Typography variant="h7" sx={{ mb: 2 ,  color: theme.palette.mode === "dark"
                      ? theme.palette.primary.dark
                      : theme.palette.primary.main,}}>
        Loading
      </Typography>
      <CircularProgress color="primary" size={60} />
    </Box>
  );
};

export default PageLoader;
